export default __webpack_public_path__ + "static/media/EclipseSpinner.d883c235.svg";